import React from 'react';
import { fromMarkdown } from '@lib/utils';
import Image from 'next/image';
import { PostcodeSearch } from '@components/Molecules/PostcodeSearch';
import {
  Background,
  CenterCharacter,
  ContentWrapper,
  LeftSection,
  RightSection,
  StyledImage,
  StyledPostcodeSearch,
} from '@factories/RowFactory/components/HeroMultiImage/styled/StyledHeroMultiImage';
import HeroMultiImageT from '@factories/RowFactory/components/HeroMultiImage/types';

export const HeroMultiImage = ({
  title,
  prePostcodeText,
  centerImage,
  images = [],
  display,
}: HeroMultiImageT) => {
  if (!display) return null;

  return (
    <Background>
      <ContentWrapper className="container">
        <LeftSection>
          <h1>{title}</h1>
          <p>{fromMarkdown({ text: prePostcodeText, isHeading: false })}</p>
          <StyledPostcodeSearch>
            <PostcodeSearch isStandalone={false} />
          </StyledPostcodeSearch>
        </LeftSection>
      </ContentWrapper>

      <RightSection>
        {images.slice(0, 3).map((image, index) => (
          <StyledImage key={index} position={index}>
            <Image
              src={image.url as string}
              alt={image.alternativeText}
              layout="fill"
              objectFit="cover"
            />
          </StyledImage>
        ))}
      </RightSection>

      <CenterCharacter>
        <Image
          src={centerImage.url as string}
          alt={centerImage.alternativeText}
          width={425}
          height={400}
          objectFit="contain"
        />
      </CenterCharacter>
    </Background>
  );
};
